import { NusukCardsIncidentReportsContent } from "./components/NusukCardsIncidentReportsContent";

export const NusukCardsReports = () => (
    <NusukCardsIncidentReportsContent />
);
